import React from 'react'
import PropTypes from 'prop-types'

import { ErrorScreen } from '@vfgroup-oneplatform/foundation/Components'

import styles from './CustomErrorScreen.Styles'

const CustomErrorScreen = ({ color, text, onPress, buttonText }) => {
  return (
    <ErrorScreen
      text={text}
      onPress={onPress}
      textButton={buttonText}
      iconStyle={styles.icon}
      backgroundStyle={styles.background(color)}
    />
  )
}

CustomErrorScreen.propTypes = {
  text: PropTypes.string,
  onPress: PropTypes.func,
  color: PropTypes.string,
  buttonText: PropTypes.string
}

CustomErrorScreen.defaultProps = {
  onPress: () => {},
  color: 'transparent',
  text: 'unlimited_error',
  buttonText: 'unlimited_try_again'
}

export default CustomErrorScreen
